import { ActiveCells } from "../../tools";

type ActivityDirection =
  | "up"
  | "right"
  | "down"
  | "left"
  | "center"
  | "same"
  | "none";

const getActivityDirections = (
  rowIndex: number,
  columnIndex: number,
  activeCells?: ActiveCells
): ActivityDirection[] => {
  if (!activeCells) {
    return ["none"];
  }

  const isTheSameCell =
    rowIndex === activeCells?.rowIndex &&
    columnIndex === activeCells.columnIndex;
  if (isTheSameCell) {
    return ["same"];
  }

  const isOnlyOneCellActive =
    !activeCells?.isFullColumn && !activeCells?.isFullRow;
  if (isOnlyOneCellActive) {
    const isLeftToActive =
      columnIndex === activeCells.columnIndex - 1 &&
      rowIndex === activeCells.rowIndex;
    if (isLeftToActive) {
      return ["left"];
    }

    const isAboveToActive =
      columnIndex === activeCells.columnIndex &&
      rowIndex === activeCells.rowIndex - 1;
    if (isAboveToActive) {
      return ["up"];
    }

    const isRightToActive =
      columnIndex === activeCells.columnIndex + 1 &&
      rowIndex === activeCells.rowIndex;
    if (isRightToActive) {
      return ["right"];
    }

    const isBelowToActive =
      columnIndex === activeCells.columnIndex &&
      rowIndex === activeCells.rowIndex + 1;
    if (isBelowToActive) {
      return ["down"];
    }

    return ["none"];
  }

  const directions: ActivityDirection[] = [];

  if (activeCells?.isFullRow) {
    const isCellAbove = activeCells.rowIndex - 1 === rowIndex;
    const isCellBelow = activeCells.rowIndex + 1 === rowIndex;
    const isCellCenter = activeCells.rowIndex === rowIndex;
    if (isCellAbove) {
      directions.push("up");
    } else if (isCellBelow) {
      directions.push("down");
    } else if (isCellCenter) {
      directions.push("center");
    }
  }

  if (activeCells?.isFullColumn) {
    const isCellRight = activeCells.columnIndex + 1 === columnIndex;
    const isCellLeft = activeCells.columnIndex - 1 === columnIndex;
    const isCellCenter = activeCells.columnIndex === columnIndex;
    if (isCellRight) {
      directions.push("right");
    } else if (isCellLeft) {
      directions.push("left");
    } else if (isCellCenter) {
      directions.push("center");
    }
  }

  return directions?.length ? directions : ["none"];
};

export default getActivityDirections;
